import {
  ButtonSecondary,
  IconInstagram,
  IconTwitter,
  cssColorValue,
  spacer16,
  semanticColors,
  screenMdMin,
} from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';

import { FooterSchema } from 'types/navigation';

const SocialContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: ${spacer16};

  @media (min-width: ${screenMdMin}) {
    flex: 1 1 auto;
    justify-content: flex-end;
  }
`;

const StyledButtonSecondary = styled(ButtonSecondary)`
  color: ${cssColorValue(semanticColors.textBase)} !important;

  &:hover {
    border-color: ${cssColorValue(semanticColors.textBase)};
  }
`;

interface Props {
  footerEntry: FooterSchema;
}

export const FooterSocial = ({ footerEntry }: Props) => {
  const { social } = footerEntry;
  if (social) {
    return (
      <SocialContainer>
        {social.twitter && (
          <StyledButtonSecondary
            href={social.twitter.href}
            target={social.twitter.target}
            iconOnly={IconTwitter}
            data-testid="footer-twitter"
            aria-label={social.twitter.title}
          />
        )}
        {social.instagram && (
          <StyledButtonSecondary
            href={social.instagram.href}
            target={social.instagram.target}
            iconOnly={IconInstagram}
            data-testid="footer-instagram"
            aria-label={social.instagram.title}
          />
        )}
      </SocialContainer>
    );
  }

  return null;
};
